import SectionReports from './SectionReports'

export default SectionReports
